<template>
    <div>
        <!-- 筛选 -->
        <my-search :inputArr="inputArr" :selectArr="selectArr" :searchParams="searchParams" @searchEvent="searchEvent" @addEvent="addEvent" @allDel="allDel" @allExport="allExport" @allImportTemplate="allImportTemplate" />

        <!-- 列表 -->
        <my-table isSelection :loading="loading" :tableData="tableData" :tableHeader="tableHeader" :pageParams="pageParams" @click.native="testNative" @handleSelectionChange="handleSelectionChange" />

        <!-- 分页组件 -->
        <my-pagination :childMsg="pageParams" @callFather="callFather" />

        <!-- 添加、修改组件 -->
        <my-dialog :isDialogShow.sync="isDialogShow" :operTitle="operTitle" :operForm="operForm" :operFormArr="operFormArr" :rules="rules" :loading="loading" :selectArrAdd="selectArrAdd" @submitForm="submitForm" />
    </div>
</template>

<script>
import _exportMethods from "@/utils/excel";
import mixins from "@/mixins/common";
import global_ from "@/common/global";
import {
    authList,
    addAuth,
    editAuth,
    delAuth,
    allDelAuth,
    detailAuth,
} from "@/network/system/auth";
export default {
    mixins: [mixins],
    provide() {
        return {
            importType: "permission",
            initData: this.getInitData,
        };
    },
    data() {
        return {
            /**
             * 当前头部数据列
             * 不需要响应式的数据可以进行冻结，Vue实例不会对数据再做数据劫持(getter、setter转换),可以提高Vue渲染性能
             * 不可以向当前对象添加、更新、删除属性。如需修改可以将变量的引用替换掉
             */
            tableHeader: Object.freeze([
                {
                    name: "方法",
                    prop: "method",
                },
                {
                    name: "权限项",
                    prop: "permission",
                },
                {
                    name: "权限名称",
                    prop: "permissionName",
                },
                {
                    name: "url",
                    prop: "url",
                },
                {
                    name: "状态",
                    prop: "status",
                },
                {
                    name: "路由信息",
                    prop: "routeUri",
                },
                {
                    name: "创建时间",
                    prop: "createTime",
                },
                {
                    name: "操作",
                    prop: "operation",
                    operation: [
                        // { name: "详情", clickFun: this.detailAuth },
                        { name: "编辑", clickFun: this.editAuth, show: true },
                        { name: "删除", clickFun: this.delAuth, show: true },
                    ],
                },
            ]),
            //筛选时文本框所需参数
            inputArr: [
                {
                    name: "userZh",
                    defaultText: "请输入权限名称",
                },
                {
                    name: "textUrl",
                    defaultText: "请输入Url",
                },
            ],
            //筛选时下拉框所需参数
            selectArr: [
                {
                    name: "type",
                    getData: "label",
                    defaultOptions: [
                        {
                            value: 1,
                            label: "POST",
                        },
                        {
                            value: 2,
                            label: "GET",
                        },
                    ],
                },
            ],
            //添加、编辑时下拉框所需参数
            selectArrAdd: [
                {
                    prop: 'status',
                    label: '权限类型',
                    getData: 'value',
                    defaultOptions: [
                        { label: "静态资源", value: 0 },
                        { label: "权限项", value: 1 },
                    ],
                },
            ],
            //添加、编辑时文本框所需参数
            operFormArr: [
                {
                    name: "method",
                    label: "方法名称",
                    defaultText: "请输入方法名称",
                },
                {
                    name: "permission",
                    label: "权限项",
                    defaultText: "请输入权限项",
                },
                {
                    name: "permissionName",
                    label: "权限名称",
                    defaultText: "请输入权限名称",
                },
                {
                    name: "url",
                    label: "url",
                    defaultText: "请输入url",
                },
                {
                    name: "routeUri",
                    label: "路由信息",
                    defaultText: "请输入路由信息",
                },
            ],
            //添加、编辑双向绑定值
            operForm: {
                id: "",
                method: "",
                permission: "",
                permissionName: "",
                url: "",
                routeUri: ""
            },
            //搜索参数
            searchParams: {
                type: "",
                userZh: "",
                textUrl: "",
            },
            // rules表单验证
            rules: {
                method: [
                    {
                        required: true,
                        message: "请输入方法名称",
                        trigger: "blur",
                    },
                ],
                permission: [
                    {
                        required: true,
                        message: "请输入权限项",
                        trigger: "blur",
                    },
                ],
                permissionName: [
                    {
                        required: true,
                        message: "请输入权限名称",
                        trigger: "blur",
                    },
                ],
                url: [
                    {
                        required: true,
                        message: "请输入url",
                        trigger: "blur",
                    },
                ],
                routeUri: [
                    {
                        required: true,
                        message: "请输入路由信息",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        getInitData(isSearch) {
            let params = {
                data: {
                    method: this.searchParams.type,
                    permissionName: this.searchParams.userZh,
                    permission: this.searchParams.permission,
                    url: this.searchParams.textUrl,
                    routeUri: this.searchParams.routeUri,
                },
                current: isSearch ? 1 : this.pageParams.currentPage,
                size: this.pageParams.pageSize,
            };
            authList(params).then((e) => {
                this.loading = false;
                let { code, data } = e.data;
                if (code == 200) {
                    this.tableData = data.records;
                    this.pageParams.total = data.total;
                    if (isSearch) this.pageParams.currentPage = 1;
                }
            });
        },
        //添加、编辑
        submitForm(valid) {
            if (valid) {
                //根据类型不同调用不同的操作接口
                let interType = this.operTitle ? addAuth : editAuth;
                interType(this.operForm).then((e) => {
                    let { code, data, msg } = e.data;
                    if (code == 200) {
                        this.isDialogShow = false;
                        this.loading = false;
                        this.getInitData();
                        this.$message.success("操作成功");
                    } else {
                        this.$message.error("操作失败");
                    }
                });
            } else {
                return false;
            }
        },
        //搜索事件
        searchEvent() {
            this.getInitData(true);
        },
        //添加事件
        addEvent() {
            this.isDialogShow = true;
            this.operTitle = true;
            this.operForm = {}; //防止多次添加有上次添加的残留数据
        },
        //编辑事件
        editAuth(item) {
            this.isDialogShow = true;
            this.operTitle = false;
            this.operForm = {
                id: item.id,
                method: item.method,
                permission: item.permission,
                permissionName: item.permissionName,
                url: item.url,
                routeUri: item.routeUri,
                status: item.status,
            };
        },
        //详情事件
        detailAuth(item) {
            detailAuth(item.id).then((e) => {
                let { code, data, msg } = e.data;
                if (code == 200) {
                    console.log(data);
                    // this.getInitData();
                    // this.$message.success("操作成功");
                } else {
                    // this.$message.error("操作失败");
                }
            });
        },
        //删除事件
        delAuth(item) {
            this.$confirm("删除该条数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                delAuth(item.id).then((e) => {
                    let { code, data, msg } = e.data;
                    if (code == 200) {
                        this.getInitData();
                        this.$message.success("操作成功");
                    } else {
                        this.$message.error("操作失败");
                    }
                });
            });
        },
        //批量删除
        allDel() {
            let data = this.selectedData;
            if (data.length == 0) {
                this.$message.warning("请选择要操作的数据！");
                return;
            }
            this.$confirm("删除所选数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let delIds = [];
                delIds = data.map((e) => e.id);
                allDelAuth({
                    ids: delIds,
                }).then((e) => {
                    let { code, data, msg } = e.data;
                    if (code == 200) {
                        this.getInitData();
                        this.$message.success("操作成功");
                    } else {
                        this.$message.error("操作失败");
                    }
                });
            });
        },
        //批量导出
        allExport() {
            let data = {
                data: {
                    method: this.searchParams.type,
                    permissionName: this.searchParams.userZh,
                    url: this.searchParams.textUrl,
                },
                current: this.pageParams.currentPage,
                size: this.pageParams.pageSize,
            };
            let exportParams = {
                method: "post",
                url: "/api/app/sys/permission/export/list",
                data,
            };
            _exportMethods(exportParams);
        },
        //导入模板
        allImportTemplate() {
            let importParams = {
                method: "get",
                url: "/api/app/sys/permission/export/template",
            };
            _exportMethods(importParams);
        },
        //在子组件上监听点击事件，如果不加.native的话，Vue会以为是自定义的事件，这样的话必须得在子组件发送一个emit事件触发才可以
        testNative() {
            console.log("native click");
        },
    },
};
</script>

<style scoped>
</style>

 
 